import { Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { organizationModule } from './Organization';
import { masterCodeModule } from './MasterCode';
import { orderUsersModule } from './OrderUsers';

@Module({ dynamic: true, store, name: 'kanriManagement', namespaced: true })
class KanriManagement extends VuexModule {
    /**
     * 運用管理以下のストアモジュールすべてをリセットする
     */
    @Action({})
    public moduleReset() {
        organizationModule.moduleReset();
        orderUsersModule.moduleReset();
        masterCodeModule.moduleReset();
    }
}

export const kanriManagementModule = getModule(KanriManagement);
